import { useEffect, useState } from "react";
import { X } from "lucide-react";

const ProfileImageViewer = ({
  src,
  alt = "Profile image",
  title,
  imageClassName = "",
  triggerClassName = "",
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  if (!src) {
    return null;
  }

  const openViewer = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  };

  const handleTriggerKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.stopPropagation();
      setOpen(true);
    }
  };

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        aria-label={`Open ${title || alt}`}
        onClick={openViewer}
        onKeyDown={handleTriggerKeyDown}
        className={`inline-flex cursor-zoom-in ${triggerClassName}`}
      >
        <img
          src={src}
          alt={alt}
          className={imageClassName}
        />
      </span>

      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label={title || alt}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 p-4 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        >
          <button
            type="button"
            aria-label="Close profile image"
            onClick={(event) => {
              event.stopPropagation();
              setOpen(false);
            }}
            className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-black/60 text-white transition hover:bg-black/80 sm:right-6 sm:top-6"
          >
            <X className="h-6 w-6" />
          </button>

          <div
            className="flex max-h-[92vh] max-w-[92vw] flex-col items-center gap-3"
            onClick={(event) => event.stopPropagation()}
          >
            <img
              src={src}
              alt={alt}
              className="max-h-[82vh] max-w-[92vw] rounded-2xl object-contain shadow-2xl"
            />

            {title && (
              <p className="max-w-[90vw] truncate rounded-full bg-black/55 px-4 py-2 text-sm font-medium text-white">
                {title}
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileImageViewer;
